import React, {useEffect, useState} from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import toastError from "../../errors/toastError";
import api from "../../services/api";
// import toastError from "../../errors/toastError";

// import { AuthContext } from "../../context/Auth/AuthContext";


const PatchNotesModal = ({ modalOpen, onClose }) => {

	// const [loading, setLoading] = useState(false);
	const [haveCloudApi, setHaveCloudApi] = useState(false);
	// const { user } = useContext(AuthContext);

	useEffect(() => {
		const delayDebounceFn = setTimeout(() => {
			const fetchOffcial = async () => {
				try {
					const { data } = await api.get("/whatsapp/api/cloud_api");
					if (data?.length > 0) {
						setHaveCloudApi(true);
					}
				} catch (err) {
					toastError(err);
				}
			};
			fetchOffcial();
		}, 500);
		return () => {
			clearTimeout(delayDebounceFn);
		};
	}, [])

	const handleClose = (_, reason) => {
		if (reason === "backdropClick" || reason === "escapeKeyDown") {
			return;
		}
		onClose();
	};


	return (
		<>
			<Dialog
				open={modalOpen}
				onClose={handleClose}
			>
				<DialogTitle
					id="form-dialog-title"
					style={{ position: "relative", paddingRight: 48 }}
				>
					{"FAQ"}
					<IconButton
						size="small"
						onClick={handleClose}
						aria-label="Fechar"
						style={{
							position: "absolute",
							right: 8,
							top: "50%",
							transform: "translateY(-50%)",
						}}
					>
						<CloseIcon fontSize="small" />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers style={{ fontSize: '13pt', lineHeight: '1.6', color: '#333' }}>
					{ !haveCloudApi && (
						<div>
							<span role="img" aria-label="star-and-alert-icon">🚨✨</span> <strong>Comunicado Importante</strong> <span role="img" aria-label="star-and-alert-icon">✨🚨</span>
						<p>
							A Meta tem intensificado as políticas de uso e está aplicando <b>restrições</b> e <b>bloqueios</b> em números que utilizam soluções baseadas em APIs não oficiais.
						</p>

						<p>
							<span role="img" aria-label="cadeado">🔐</span>{" "}
							Para garantir sua segurança e continuidade no atendimento, somos <b>parceiros da Meta</b>.
							<br/>
							Caso ocorra qualquer instabilidade ou bloqueio, realizamos todo o processo de <b>migração para a API Oficial do WhatsApp</b>, assegurando estabilidade e conformidade com as regras atuais.
						</p>

						<p>
							<span role="img" aria-label="raio">⚡</span>{" "}
							Pensando em tornar esse processo <b>mais rápido e sem imprevistos</b>, recomendamos que sua empresa já realize a <b>criação do portfólio</b> e a <b>verificação junto à Meta</b>.
						</p>

						<p>
							<strong>
								<span role="img" aria-label="link">🔗</span>{' '}
								<a
									href="https://docs.google.com/presentation/d/e/2PACX-1vSe_xDpbXrtxosxRv-rB67mBtrWPZ_Dpo89uYz2cayS3VVw0MCAdcFpD6nHs4pQy2DosxhP309V6AlW/pub?start=true&loop=false&delayms=5000"
									target="_blank"
									rel="noopener noreferrer"
									style={{ color: '#1976d2', textDecoration: 'none' }}
								>
									Clique aqui
								</a>
							</strong> e descubra como as novas políticas da Meta afetarão seu uso.
						</p>

						<p style={{ marginTop: 12 }}>
							<strong>Assista o vídeo abaixo: <span role="img" aria-label="FingerDown">👇🏻</span><span role="img" aria-label="FingerDown">👇🏻</span></strong>
						</p>

						<div
							style={{
								marginTop: '1rem',
								padding: '12px',
								background: '#f5f7fa',
								borderRadius: 10,
								boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
							}}
						>
							<div style={{ maxWidth: 270, margin: '0 auto' }}>
								<video
									controls
									preload="metadata"
									playsInline
									style={{
										width: '100%',
										borderRadius: 8,
										backgroundColor: '#000',
									}}
								>
									<source
										src="https://app.goneweb.com.br/patch_notes/public/cloudapi.mp4"
										type="video/mp4"
									/>
									Seu navegador não suporta vídeo.
								</video>
							</div>
						</div>
						</div>
					)}

					<h3 style={{ marginBottom: '0.5rem', color: '#1976d2' }}>
						<span role="img" aria-label="megafone">📢</span> Notas de Atualização
					</h3>
										
					<p>Fique por dentro das mais recentes atualizações do nosso sistema!</p>

					<p>
						<strong>
							<span role="img" aria-label="link">🔗</span>{' '}
							<a
								href="https://faq.whatscontabil.com.br/"
								target="_blank"
								rel="noopener noreferrer"
								style={{ color: '#1976d2', textDecoration: 'none' }}
							>
								Clique aqui
							</a>
						</strong> e acesse agora mesmo para descobrir todas as novidades disponíveis para você.
					</p>

					<p>
						<span role="img" aria-label="documento">📄</span>{' '}
						<strong>Documentação:</strong>&nbsp;
						<a
							href="https://faq.whatscontabil.com.br/docs/"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: '#1976d2', fontWeight: 'bold', textDecoration: 'none' }}
						>
							Visualizar
						</a>
					</p>

					<p style={{ marginTop: '4rem', fontStyle: 'italic', fontSize: '11pt' }}>
						<span role="img" aria-label="pacote">📦</span> Versão:&nbsp;<b>v7.1.4</b>
					</p>
				</DialogContent>

				<DialogActions>
					<Button
						onClick={handleClose}
						color="secondary"
						// disabled={loading}
						variant="outlined"
					>
						{"Fechar"}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default PatchNotesModal;
